import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const InputGroupCardUiOptionsSchema = z.object({
  autofocus: z.boolean().optional(),
  errorMessage: z.string().optional(),
});

// Transforms the Zod schema to a TypeScript type
export type InputGroupCardUiOptions = z.infer<
  typeof InputGroupCardUiOptionsSchema
>;

/* The field schema for the InputGroupCard field extension */
export const InputGroupCardSchema = makeFieldSchemaFromZod(
  z.string().describe('Input Group Card'),
  InputGroupCardUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type InputGroupCardProps = typeof InputGroupCardSchema.type;

/* The final schema used for the field extension */
export const InputGroupCardSchemaFinal = InputGroupCardSchema.schema;
